import React, { useState } from 'react';
import './index.css';

function App() {
  const [inputText, setInputText] = useState('');
  const [generatedPost, setGeneratedPost] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGenerate = async () => {
    if (!inputText.trim()) {
      setError('Please enter job information');
      return;
    }

    setLoading(true);
    setError('');
    setGeneratedPost('');

    try {
      const apiUrl = `${(process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/$/, '')}/api/generate-post`;

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text: inputText }),
      });

      if (!response.ok) {
        throw new Error('Failed to generate post');
      }

      const data = await response.json();
      setGeneratedPost(data.generatedPost);
    } catch (err) {
      setError('Error generating post. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app">
      <header className="header">
        <h1>LinkedIn Job Post Generator</h1>
        <p>Paste job details and generate optimized LinkedIn posts using AI</p>
      </header>

      <div className="input-section">
        <h2>Job Information</h2>
        <textarea
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Paste the raw job posting text here. Include company name, role, link, date posted, etc."
        />
        <br />
        <button onClick={handleGenerate} disabled={loading}>
          {loading ? 'Generating...' : 'Generate Post'}
        </button>
        {error && <p className="error">{error}</p>}
      </div>

      <div className="output-section">
        <h2>Generated LinkedIn Post</h2>
        <div className="output">
          {generatedPost || 'Your generated post will appear here...'}
        </div>
      </div>
    </div>
  );
}

export default App;